var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLogoGooglePlay = function SvgLogoGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-100 -80 600 620"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.7 142.3L15 1.3C11.9-.5 8-.4 5 1.4c-3.1 1.8-5 5-5 8.6 0 0 .1 13 .2 34.4l179.7 179.7z",
    fill: "#63be6b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.2 44.4C.5 121.6 1.4 309 1.8 402.3L180 224.1z",
    fill: "#3ec6f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.9 223l-141.2-80.7-81.9 81.8 92.4 92.4L403 240.3c3.1-1.8 5-5.1 5-8.6 0-3.6-2-6.9-5.1-8.7z",
    fill: "#faa51a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 402.3c.2 33.3.3 54.6.3 54.6 0 3.6 1.9 6.9 5 8.6 3.1 1.8 6.9 1.8 10 0l255.3-148.9-92.4-92.4z",
    fill: "#ec3b50"
  })));
};
export default SvgLogoGooglePlay;